export enum DealActionEnum {
  "BUY",
  "SELL",
  "BALANCE",

  "CREDIT",

  "CHARGE",

  "CORRECTION",

  "BONUS",

  "COMMISSION",

  "COMMISSION DAILY",

  "COMMISSION MONTHLY",

  "AGENT DAILY",

  "AGENT MONTHLY",

  "INTERESTRATE",

  "BUY CANCELED",

  "SELL CANCELED",

  "DIVIDEND",

  "DIVIDEND FRANKED",

  "TAX",

  "AGENT",

  "SO COMPENSATION",

  "SO COMPENSATION CREDIT",
  "FIRST",
  "LAST",
}

export enum DealEntryEnum {
  "ENTRY IN",

  "ENTRY OUT",

  "ENTRY INOUT",

  "ENTRY OUT BY",

  "ENTRY FIRST",

  "ENTRY LAST",
}

export enum DealReasonEnum {
  "CLIENT",

  "EXPERT",

  "DEALER",

  "SL",

  "TP",

  "SO",

  "ROLLOVER",

  "EXTERNAL CLIENT",

  "VMARGIN",

  "GATEWAY",

  "SIGNAL",

  "SETTLEMENT",

  "TRANSFER",

  "SYNC",

  "EXTERNAL SERVICE",

  "MIGRATION",

  "MOBILE",

  "WEB",

  "SPLIT",

  "CORPORATE ACTION",

  "FIRST",

  "LAST",
}
